import { render, staticRenderFns } from "./searchRhyme.vue?vue&type=template&id=64001646&scoped=true&"
import script from "./searchRhyme.vue?vue&type=script&lang=js&"
export * from "./searchRhyme.vue?vue&type=script&lang=js&"
import style0 from "./searchRhyme.vue?vue&type=style&index=0&id=64001646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64001646",
  null
  
)

export default component.exports